import { useTicketStatuses } from "@jugl-web/domain-resources/tickets/hooks/useTicketStatuses";
import { TicketStatus } from "@jugl-web/rest-api/tickets/models/common-types";
import {
  ListBoxItem,
  ResourcePickerPopover,
  ResourcePickerPopoverProps,
} from "@jugl-web/ui-kit";
import { useMemo } from "react";

interface TicketStatusPickerPopoverProps
  extends Pick<ResourcePickerPopoverProps<TicketStatus>, "renderTrigger"> {
  status: TicketStatus;
  onChange: (status: TicketStatus) => void;
}

export const TicketStatusPickerPopover = ({
  status,
  onChange,
  renderTrigger,
}: TicketStatusPickerPopoverProps) => {
  const { statuses, getStatusById } = useTicketStatuses();

  const statusListItems = useMemo<ListBoxItem<TicketStatus>[]>(
    () =>
      statuses.map((statusItem) => ({
        id: statusItem.id,
        value: statusItem.id,
      })),
    [statuses]
  );

  const handleSelect = (newStatus: TicketStatus) => {
    if (newStatus === status) {
      return;
    }

    onChange(newStatus);
  };

  return (
    <ResourcePickerPopover
      placement="bottom"
      className="w-[312px]"
      items={statusListItems}
      selectionBehavior={{ mode: "single", canToggle: false }}
      defaultSelectedIds={[status]}
      itemSize="md"
      spaceBetweenItems="compact"
      renderLabel={(item) => getStatusById(item.value).label}
      renderStartIcon={(item) => getStatusById(item.value).icon}
      renderTrigger={renderTrigger}
      onSelect={({ item, onClose }) => {
        handleSelect(item.value);
        onClose();
      }}
    />
  );
};
